module.exports = __webpack_public_path__ + "static/media/hero.3cd7c2c2.jpg";